import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { FormTextInputProps } from './FormInputProps';

/**
 * Password input wrapper around FormInputText.
 */
export const FormInputPassword = (props: FormTextInputProps) => {
  return <FormInputText {...props} textFieldProps={{ ...props.textFieldProps, type: 'password' }} />;
};

/**
 * Textarea input wrapper around FormInputText.
 * @param rows - Number of visible text rows
 */
export const FormInputTextArea = (props: FormTextInputProps & { rows: number }) => {
  return <FormInputText {...props} textFieldProps={{ ...props.textFieldProps, multiline: true, rows: props.rows }} />;
};

/**
 * Standard text input component with react-hook-form integration.
 * Handles validation errors and supports read-only/disabled states.
 */
export const FormInputText = ({ register, name, control, label, readOnly, disabled, textFieldProps, inputProps, helperText }: FormTextInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : helperText ? helperText : undefined}
          error={!!error}
          onChange={onChange}
          value={value || ''}
          fullWidth
          InputLabelProps={{
            ...(disabled ? { shrink: true } : {}),
            ...(textFieldProps && textFieldProps.InputLabelProps ? textFieldProps.InputLabelProps : {}),
          }}
          label={label}
          {...(typeof disabled !== 'undefined' ? { disabled } : {})}
          inputProps={{
            ...(typeof readOnly !== 'undefined' ? { readOnly } : {}),
            ...inputProps,
          }}
          {...textFieldProps}
        />
      )}
      {...register}
    />
  );
};
